import { useDispatch, useSelector } from 'react-redux';

import {
    login,
    signUp,
    resetPassword,
    resetPasswordCode,
    resetPasswordNewPassword,
} from '@core/actions/UserActions';

// Wraps the @core UserActions so bidding components stay framework-agnostic.
// Returns { user, authorized, registered, error, submit* } — each submit* resolves
// with the action payload and throws on failure so UI code can branch on it.
export default function useAuth() {
    const dispatch = useDispatch();
    const { user, authorized, registered, resetPasswordSent } = useSelector(state => state.user);

    const run = async (actionCreator, data) => {
        const result = await dispatch(actionCreator(data));
        if (result?.error) {
            throw result.payload;
        }
        return result.payload;
    };

    return {
        user,
        authorized,
        registered,
        resetPasswordSent,
        submitLogin: (data) => run(login, data),
        submitSignUp: (data) => run(signUp, data),
        submitResetRequest: (data) => run(resetPassword, data),
        submitResetCode: (data) => run(resetPasswordCode, data),
        submitResetNewPassword: (data) => run(resetPasswordNewPassword, data),
    };
}
